<template>
    <form role="form" method="POST" action="/login" @submit.prevent="submit" novalidate>
        <form-input-type-email
            name="email"
            :label="__('Your email')"
            :errors="errors.email"
            required
            full-border
        ></form-input-type-email>

        <!-- FIXME: nesedi "zobrazit heslo". Kde mame pass input v design systemu? -->
        <form-input-type-password
            name="password"
            :label="__('Your password')"
            :errors="errors.password"
            required
            full-border
        ></form-input-type-password>

        <p class="form-mandatory-fields">{{ __('* Fields marked with an asterisk (*) are mandatory.') }}</p>

        <slot></slot>
        
        <v-button :label="__('Log in')" size="lg" position="center" type="submit"></v-button>
    </form>
</template>

<script>
    export default {
        data() {
            return {
                errors: {}
            }
        },
        mounted() {
            $('.auth-page').animate({ opacity: 1 }, 300)
            $('.login').animate({ opacity: 1 }, 300)
        },
        methods: {
            submit() {
                let formData = {}

                // serialize form data
                $(this.$el)
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData[name] = value
                    })

                axios
                    .post('login', formData)
                    .then(async ({ data }) => {
                        if (data.error) {
                            alert(data.error)
                        }

                        window.location.replace(data.redirect)
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        Vuemit.fire('Button--sending-failed', true)
                    })
            }
        }
    }
</script>
